import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const login = async () => {
    setError("");
    const csrfRes = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/csrf-token`, {
      credentials: "include"
    });
    const { csrfToken } = await csrfRes.json();

    const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "CSRF-Token": csrfToken
      },
      credentials: "include",
      body: JSON.stringify({ email, password })
    });

    if (res.ok) {
      navigate("/admin");
    } else {
      setError("Ongeldige inloggegevens.");
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") login();
  };

  return (
    <div className="pane pane-center dark_pane">
      <h1>Admin login</h1>
      <label htmlFor="email">E-mailadres</label>
      <input
        id="email"
        type="email"
        value={email}
        onChange={e => setEmail(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder="admin@voorbeeld.nl"
        autoComplete="email"
      />
      <label htmlFor="password">Wachtwoord</label>
      <input
        id="password"
        type="password"
        value={password}
        onChange={e => setPassword(e.target.value)}
        onKeyDown={handleKeyDown}
        autoComplete="current-password"
      />
      {error && <p style={{ color: "red" }}>{error}</p>}
      <button onClick={login}>Inloggen</button>
    </div>
  );
}
